export const BatchGlosses = () => import(
  /* webpackChunkName: "billing-gloss" */ '@/app/billing/gloss/components/BatchGlosses.vue'
);
export const BatchAppeals = () => import(
  /* webpackChunkName: "billing-gloss" */ '@/app/billing/gloss/components/BatchAppeals.vue'
);
export const BatchStatements = () => import(
  /* webpackChunkName: "billing-gloss" */ '@/app/billing/gloss/components/BatchStatements.vue'
);
export const ImportStatementModal = () => import(
  /* webpackChunkName: "billing-gloss" */ '@/app/billing/gloss/modals/ImportStatementModal.vue'
);
export const GuideModal = () => import(
  /* webpackChunkName: "billing-guide" */ '@/app/billing/guide/modals/GuideModal.vue'
);
